import dayjs from 'dayjs';
import { BaseQuery, IssueType } from 'generated/graphql';
import { Maybe } from 'graphql/jsutils/Maybe';

interface BaseQueryFieldsInputUpdate {
  sourceText: string;
  targetText?: Maybe<string>;
  deadline: string;
  targetLanguage: string;
  issueType: IssueType;
  details?: Maybe<string>;
  id: number;
  qeReview: boolean;
  assignee: Maybe<string>;
}

export const mapBaseQueryFields = (q: BaseQuery, assignee?: string): BaseQueryFieldsInputUpdate => {
  return {
    sourceText: q.sourceText as string,
    targetText: q.targetText,
    deadline: dayjs(q.deadline).format('YYYY-MM-DD'),
    targetLanguage: q.targetLanguage,
    issueType: q.issueType,
    details: q.details,
    id: Number(q.id),
    qeReview: q.qeReview,
    assignee: assignee != undefined ? assignee : q.assignee
  };
};
